var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCuttingEdgeProtection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 201,
    viewBox: "0 0 400 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_5314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.617188H400V200.617H0V0.617188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 132.617C171 111.63 188.013 94.6172 209 94.6172C229.987 94.6172 247 111.63 247 132.617V139.617H171V132.617Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 132.617C181 117.153 193.536 104.617 209 104.617C224.464 104.617 237 117.153 237 132.617V139.617H181V132.617Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258 139.617H270V191.617C270 196.035 266.418 199.617 262 199.617H258V139.617Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeDasharray: "6.4 6.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 140.617C339 68.8202 280.797 10.6172 209 10.6172C153.777 10.6172 106.596 45.05 87.7559 93.6172",
    stroke: "black",
    strokeWidth: 1.5,
    strokeDasharray: "6.4 6.4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 93.6172,
    r: 6,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 147.617C150 143.199 153.582 139.617 158 139.617H162V199.617H150V147.617Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 139.617,
    width: 96,
    height: 60,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 166.617,
    r: 6.25,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209 173.617V185.617",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 167.617,
    r: 32,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344,
    cy: 167.617,
    r: 32,
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.357 149.617V185.617",
    stroke: "white",
    strokeWidth: 1.92857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.071 149.617V185.617",
    stroke: "white",
    strokeWidth: 1.92857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.357 167.616H347.357C350.552 167.616 353.143 165.026 353.143 161.831C353.143 158.635 350.552 156.045 347.357 156.045H338.357V167.616Z",
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.571 156.045H338.357M338.357 156.045H347.357C350.552 156.045 353.143 158.635 353.143 161.831V161.831C353.143 165.026 350.552 167.616 347.357 167.616H338.357V156.045Z",
    stroke: "white",
    strokeWidth: 1.92857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.357 167.618H348.643C351.838 167.618 354.428 170.208 354.428 173.404C354.428 176.599 351.838 179.189 348.643 179.189H338.357V167.618Z",
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.571 179.189H338.357M338.357 179.189H348.643C351.838 179.189 354.428 176.599 354.428 173.404V173.404C354.428 170.208 351.838 167.618 348.643 167.618H338.357V179.189Z",
    stroke: "white",
    strokeWidth: 1.92857
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115 140.617C115 88.7024 157.085 46.6172 209 46.6172C260.915 46.6172 303 88.7024 303 140.617H279C279 121.16 271.062 103.557 258.247 90.8707L263.904 85.2137C249.809 71.2449 230.412 62.6172 209 62.6172C187.408 62.6172 167.866 71.3905 153.742 85.5667L159.399 91.2235C146.792 103.883 139 121.34 139 140.617H115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 140.617H114.25V141.367H115V140.617ZM303 140.617V141.367H303.75V140.617H303ZM279 140.617H278.25V141.367H279V140.617ZM258.247 90.8707L257.717 90.3404L257.184 90.8734L257.72 91.4037L258.247 90.8707ZM263.904 85.2137L264.435 85.744L264.967 85.2113L264.432 84.681L263.904 85.2137ZM153.742 85.5667L153.211 85.0374L152.683 85.5677L153.212 86.097L153.742 85.5667ZM159.399 91.2235L159.93 91.7527L160.459 91.2224L159.929 90.6932L159.399 91.2235ZM139 140.617V141.367H139.75V140.617H139ZM209 45.8672C156.671 45.8672 114.25 88.2882 114.25 140.617H115.75C115.75 89.1166 157.499 47.3672 209 47.3672V45.8672ZM303.75 140.617C303.75 88.2882 261.329 45.8672 209 45.8672V47.3672C260.501 47.3672 302.25 89.1166 302.25 140.617H303.75ZM279 141.367H303V139.867H279V141.367ZM279.75 140.617C279.75 120.952 271.726 103.16 258.775 90.3377L257.72 91.4037C270.398 103.955 278.25 121.369 278.25 140.617H279.75ZM258.778 91.4011L264.435 85.744L263.374 84.6834L257.717 90.3404L258.778 91.4011ZM264.432 84.681C250.202 70.5787 230.618 61.8672 209 61.8672V63.3672C230.207 63.3672 249.416 71.9112 263.376 85.7464L264.432 84.681ZM209 61.8672C187.201 61.8672 167.469 70.7257 153.211 85.0374L154.274 86.0961C168.262 72.0553 187.616 63.3672 209 63.3672V61.8672ZM153.212 86.097L158.869 91.7538L159.929 90.6932L154.273 85.0364L153.212 86.097ZM158.868 90.6943C146.127 103.488 138.25 121.134 138.25 140.617H139.75C139.75 121.546 147.458 104.277 159.93 91.7527L158.868 90.6943ZM115 141.367H139V139.867H115V141.367Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 183.617,
    width: 24,
    height: 16,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 189.617,
    width: 24,
    height: 10,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 175.617H68C72.4183 175.617 76 179.199 76 183.617V199.617H32V175.617Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 174.617L46 99.6172",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 109.617H66C68.2091 109.617 70 111.408 70 113.617V135.617H46V109.617Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 114.617H94L93.4232 116.242C90.8107 123.6 90.8107 131.634 93.4232 138.993L94 140.617H74C71.7909 140.617 70 138.826 70 136.617V114.617Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_5314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 200,
    fill: "white",
    transform: "translate(0 0.617188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuttingEdgeProtection);
export default __webpack_public_path__ + "static/media/cutting_edge_protection.b2689aa44a483687357f7d3a498c79ac.svg";
export { ForwardRef as ReactComponent };